/**
 * Optional columns for the AI interviews list (localStorage per org).
 * Base columns are always: Candidate, Session date, Score, Status, Action.
 */

export type AiInterviewExtraColumnKey =
  | 'scheduled_by'
  | 'round'
  | 'language'
  | 'created_at'
  | 'expires_at'
  | 'scheduled_at'
  | 'slot_status'
  | 'application_id';

export const AI_INTERVIEW_EXTRA_COLUMN_META: { key: AiInterviewExtraColumnKey; label: string }[] = [
  { key: 'scheduled_by', label: 'Scheduled by' },
  { key: 'round', label: 'Round' },
  { key: 'language', label: 'Language' },
  { key: 'created_at', label: 'Created' },
  { key: 'expires_at', label: 'Expires' },
  { key: 'scheduled_at', label: 'Calendar slot (scheduled)' },
  { key: 'slot_status', label: 'Slot status (pipeline)' },
  { key: 'application_id', label: 'Application ID' },
];

export type AiInterviewsTablePolicy = {
  extraColumns: AiInterviewExtraColumnKey[];
};

function storageKey(orgId: string): string {
  return `ggj.b2b.aiInterviews.table.${orgId}`;
}

export function defaultAiInterviewsTablePolicy(): AiInterviewsTablePolicy {
  return { extraColumns: [] };
}

export function loadAiInterviewsTablePolicy(orgId: string): AiInterviewsTablePolicy {
  try {
    const raw = localStorage.getItem(storageKey(orgId));
    if (!raw) return defaultAiInterviewsTablePolicy();
    const p = JSON.parse(raw) as Partial<AiInterviewsTablePolicy>;
    if (!Array.isArray(p.extraColumns)) return defaultAiInterviewsTablePolicy();
    const allowed = new Set(AI_INTERVIEW_EXTRA_COLUMN_META.map((m) => m.key));
    return {
      extraColumns: p.extraColumns.filter((k): k is AiInterviewExtraColumnKey => allowed.has(k as AiInterviewExtraColumnKey)),
    };
  } catch {
    return defaultAiInterviewsTablePolicy();
  }
}

export function saveAiInterviewsTablePolicy(orgId: string, policy: AiInterviewsTablePolicy): void {
  localStorage.setItem(storageKey(orgId), JSON.stringify(policy));
}
